/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Map from 'can/map/map';
import List from 'scripts/models/base/list';
import can from 'can/util/util';
import 'can/map/define/define';
import 'can/map/validations/validations';

export default Map.extend({

    setup: function (baseMap) {

        Map.setup.apply(this, arguments);
        this.List = List.extend({
            Map: this
        }, {});

        if(baseMap.prototype.define) {
            var defines = can.simpleExtend({}, baseMap.prototype.define)
            can.simpleExtend(defines, this.prototype.define);
            this.prototype.define = defines;
        }
    }

}, {

    dispatch: function (event, args) {
        can.batch.trigger(this, event, args);
    },

    merge: function (key, value) {
        var oldValue = this.attr(key);
        var newValue = can.extend({}, oldValue.serialize(), value);
        return this.attr(key, newValue);
    },

    startBatch: function (callback) {
        if (callback) {
            callback = this.proxy(callback);
        }
        can.batch.start(callback);
    },

    stopBatch: function () {
        can.batch.stop();
    },

    waitForProperty: function (property, cb) {
        const d = can.Deferred();
        const value = this.attr(property);

        const resolver = (val) => {
            d.resolve(val);
            if (can.isFunction(cb)) {
                cb(val);
            }
        };

        if (value !== undefined) {
            resolver(value);
        }
        else {
            this.bind(property, (event, newValue, oldValue) => {
                resolver(newValue);
            });
        }

        return d;
    }

}).extend({}, can.event);
